import React from 'react';
import { Field, reduxForm } from 'redux-form';
import axios from 'axios';

import TextareaField from '../shared/form-elements/textarea';
import ModalBox from '../shared/modal';

import './comment-form.less';

class CommentTd extends React.Component {
	constructor(props) {
		super(props);
		this.submitComment = this.submitComment.bind(this);
	}
	submitComment({ chat_id, message_id, comment }) {
		return axios({
			method: 'PUT',
			url: 'v2/traffic-alerts/comment',
			data: { chat_id, message_id, comment }
		})
			.then(this.props.apply);
	}
	render() {
		const { handleSubmit, row } = this.props;
		return (
			<form
				className="comment-form"
				autoComplete="off"
				onSubmit={handleSubmit(data => this.submitComment({...row, ...data }))}
			>
				<Field name="comment" component={TextareaField} showLabel={false} />
				<button className="ui-btn ui-btn-primary margin-10-0">
					Submit
				</button>
			</form>
		);
	}
}

const CommentForm = reduxForm({})(CommentTd);

class CommentFormModal extends React.Component {
	constructor(props) {
		super(props);
		this.state = { isOpened: false };
	}

	render() {
		const { props } = this;

		return (
			<div
				className="comment-cell"
				onClick={(e) => {
					e.preventDefault();
					e.stopPropagation();
					this.setState(state => ({ isOpened: !state.isOpened }));
				}}
			>
				<span>{ props.row.comment || '-' }</span>
				<a className="action_edit" />
				<ModalBox
					body={
						<CommentForm
							{...props}
							initialValues={{ comment: props.row.comment || '' }}
							apply={props.apply}
							form={`alerts_comment_form_${props.row.message_id || '_'}_${props.row.chat_id || '_'}`}
						/>
					}
					isOpen={this.state.isOpened}
					onClose={() => this.setState({ isOpened: false })}
					title={`${props.intl('Редактировать коментарий')}`}
				/>
			</div>
		);
	}
}

export default function renderCommentTd(_, props) {
	return (
		<CommentFormModal {...props} />
	);
}



// WEBPACK FOOTER //
// ./frontend/admin-dashboard/src/modules/alerts-analytics/render-comment-td.js